import { Component, OnInit, Input } from '@angular/core';
import { IntlService } from '../../core/services/intl.service';
import { addMinutes, format } from 'date-fns';
import { NgIf, NgFor, CurrencyPipe, DatePipe } from '@angular/common';
import { DateFixPipe } from '../../shared-with-client/pipes/date-fix.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-client-success',
    templateUrl: './client-success.component.html',
    styleUrls: ['./client-success.component.scss'],
    imports: [
        NgIf,
        NgFor,
        CurrencyPipe,
        DatePipe,
        DateFixPipe,
        TranslatePipe
    ],
    standalone: true
})
export class ClientSuccessComponent implements OnInit {
  @Input() booking;
  @Input() store;
  @Input() payOnlyPage = false;

  formatTime: string;
  mbrefTimeLimit: Date;
  mbrefTime: string;


  constructor(private intlService: IntlService) { }

  ngOnInit() {
    this.formatTime = this.intlService.getTimeFormatShort();

    this.mbrefTimeLimit = addMinutes(new Date(), this.store.cancelMbrefAfterMinutes);

    this.mbrefTime = `10m`;

    if (this.store.cancelMbrefAfterMinutes) {
      if (this.store.cancelMbrefAfterMinutes > 60) {
        this.mbrefTime = `${Math.floor(this.store.cancelMbrefAfterMinutes / 60)}h`;
        this.formatTime = this.intlService.getDateTimeFormatShort();
      } else {
        this.mbrefTime = `${this.store.cancelMbrefAfterMinutes}m`;
      }
    }
  }

  convertMBref(mbref) {
    const groups = mbref.match(/.{1,3}/g); // split into groups of 3 characters
    return groups.join(" ");
  }
}
